module.exports = __webpack_public_path__ + "static/media/golden-food-beverage-image@2x.211b464c.png";